import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import TableCell from '@mui/material/TableCell';

import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import useLanguage from '../../../../components/_hook/useLanguage';
import BaseImage from '../../../../components/_image/BaseImage';
import { IProductSchema } from '../../../../../graphql/type/product';
import CopyIconButton from '../../../../components/_iconButton/CopyIconButton';
import useRoutes from '../../../../components/_hook/useRoutes';
import SchemaCompanyName from '../../../../components/_schema/SchemaCompanyName';
import useKeepitalRoutes from '../../../../components/_hook/useKeepitalRoutes';
import FormProductBatchUpdateKeyword from '../../_module/FormProductBatchUpdateKeyword/formProductBatchUpdateKeyword';

interface IProps {
  item: IProductSchema;
  setTableRefreshKey?: (tableRefreshKey: number) => void;
}

export default function DropshippedCategoryAssignmentProductTableItem(
  props: IProps
) {
  const { t } = useTranslation();
  const { item, setTableRefreshKey } = props;
  const { path } = useRoutes();
  const { getText } = useLanguage();
  const { path: keepitalPath } = useKeepitalRoutes();
  const [isOpenBatchDialog, setIsOpenBatchDialog] = useState(false);
  const images = item.media && item.media.images ? item.media.images : [];
  const image = images.find((tempImage) => tempImage.status);
  // Classifications
  const productClassifications =
    item.keywords && item.keywords.classificationsData
      ? item.keywords.classificationsData
      : [];
  const productClassificationsString = productClassifications
    .map((classification) => classification.name)
    .join(', ');
  // Brands
  const productBrands =
    item.keywords && item.keywords.brandsData ? item.keywords.brandsData : [];
  const productBrandsString = productBrands
    .map((brand) => brand.name)
    .join(', ');
  // Tags
  const productTags =
    item.keywords && item.keywords.tagsData ? item.keywords.tagsData : [];
  const productTagsString = productTags.map((tag) => tag.name).join(', ');

  return (
    <>
      <Dialog
        open={isOpenBatchDialog}
        onClose={() => setIsOpenBatchDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <FormProductBatchUpdateKeyword
          onCancel={() => setIsOpenBatchDialog(false)}
          productIds={[item._id]}
          onSubmit={() => {
            setIsOpenBatchDialog(false);
            if (setTableRefreshKey) {
              setTableRefreshKey(new Date().getTime());
            }
          }}
        />
      </Dialog>
      <TableCell align="left">
        <Tooltip title={item._id}>
          <Button color="primary" onClick={() => setIsOpenBatchDialog(true)}>
            {item._id.substr(0, 6)}
          </Button>
        </Tooltip>
        <CopyIconButton iconHtmlFontSize="0.8rem" copyText={item._id} />
      </TableCell>
      <TableCell align="center">
        <Button
          color="primary"
          component="a"
          href={keepitalPath('company.showcase.product.index', {
            origin:
              item.companyData && item.companyData.origin
                ? item.companyData.origin.toLowerCase()
                : '',
            companySlug:
              item.companyData && item.companyData.slug
                ? item.companyData.slug
                : '',
            productSlug: item.slug,
          })}
          target="_blank"
        >
          {getText(item.name)}
        </Button>
        <CopyIconButton
          iconHtmlFontSize="0.8rem"
          copyText={getText(item.name)}
        />
      </TableCell>
      <TableCell align="center">
        {item.sourceDropshippedProductCompanyData && (
          <Button
            color="primary"
            component={Link}
            to={path('product.dropshipped.vendor.detail', {
              companyID: item.company,
              toCompanyID: item.sourceDropshippedProductCompanyID,
            })}
          >
            <SchemaCompanyName
              company={item.sourceDropshippedProductCompanyData}
              showVerification
            />
          </Button>
        )}
      </TableCell>
      <TableCell align="center">
        {image ? (
          <BaseImage
            src={image.filenameSmallUrl || image.filenameUrl}
            style={{
              maxWidth: '100px',
              height: '35px',
            }}
            lightboxImages={images.map((tempImage) => tempImage.filenameUrl)}
            title={getText(item.name)}
            alt={getText(item.name)}
          />
        ) : (
          <span>{`${t('no')} ${t('image')}`}</span>
        )}
      </TableCell>
      <TableCell align="center">
        {productClassificationsString || '-'}
      </TableCell>
      <TableCell align="center">{productBrandsString || '-'}</TableCell>
      <TableCell align="center">{productTagsString || '-'}</TableCell>
    </>
  );
}
